export default __webpack_public_path__ + "static/media/bg-pricing.90e3b6f2.jpg";